import { mergeClasses, useRestoreFocusSource } from "@fluentui/react-components";

import { FlyoutContext } from "./FlyoutProvider";
import { M365PulseDrawer } from "../Drawer/M365PulseDrawer";
import { M365PulseFlyoutProps } from "./M365PulseFlyout.types";
import React from "react";
import { observer } from "mobx-react";
import { useM365PulseFlyoutStyles } from "./M365PulseFlyout.styles";

const M365PulseFlyoutBase = ({
    isOpen,
    title,
    onRequestClose,
    children,
    size,
    width,
    position,
    hideHeader,
    className,
    isLightDismiss,
    mountNode,
    footerActions,
    contentClassNames,
    showLeftNavigation,
    onLeftNavigation
}: M365PulseFlyoutProps) => {
    const restoreFocusSourceAttribute = useRestoreFocusSource();
    const classes = useM365PulseFlyoutStyles();
    const rootStyle = mergeClasses(classes.root, contentClassNames?.root);
    const bodyStyle = mergeClasses(classes.body, contentClassNames?.body);
    return (
        <FlyoutContext value>
            <M365PulseDrawer
                size={size}
                position={position}
                showDismiss
                title={title}
                onRequestClose={onRequestClose}
                isOpen={isOpen}
                width={width}
                hideHeader={hideHeader}
                className={className}
                modalType={isLightDismiss ? "modal" : "alert"}
                mountNode={mountNode}
                showLeftNavigation={showLeftNavigation}
                onLeftNavigation={onLeftNavigation}
                footerActions={footerActions}
            >
                <div className={rootStyle}>
                    <div className={bodyStyle} {...restoreFocusSourceAttribute}>
                        {children}
                    </div>
                </div>
            </M365PulseDrawer>
        </FlyoutContext>
    );
};

export const M365PulseFlyout = observer(M365PulseFlyoutBase);
